import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useParticipantIds, useActiveParticipant, useDaily } from '@daily-co/daily-react';
import { pageAtom, isAuthAtom, customAvatarAtom } from '../../State';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
import { ReactComponent as BackgroundSVG } from '../Images/buttons/backgroundBlack.svg';
import { ReactComponent as MusicSVG } from '../Images/buttons/musicBlack.svg';
import KUTE from 'kute.js';
import './NFT.css';
import 'react-loading-skeleton/dist/skeleton.css';
import NFTItem from './NFTItem';
import Loading from '../Loading/Loading';

import { useTranslation } from 'react-i18next';
import { getImagePath } from '../Util/utils';
import { isMobile } from 'react-device-detect';
import isElectron from '../../Global';
import NFTMyCustom from './NFTMyCustom';
import NFTMyCustomUpload from './NFTMyCustom_old';
import NFTBackground from './NFTBackground';
import NFTBGM from './NFTBGM';
import NFTOriginal from './NFTOriginal';

export default function NFTBack({ isFaceScreen = false, userType }) {
  const callObject = useDaily();

  //Recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const [customAvatarState, setCustomAvatarState] = useRecoilState(customAvatarAtom);
  const { t, i18n } = useTranslation();

  //その他
  const [nftType, setNftType] = useState('background');
  const [loadingState, setLoadingState] = useState(false);
  const [metaLoadingState, setMetaLoadingState] = useState(false);
  const [uniqueState, setUniqueState] = useState(null);
  const [editState, setEditState] = useState(null);

  const navigate = useNavigate();

  //初回ロード時
  useEffect(() => {
    //アニメーション開始
    startAnimation();

    return () => {};
  }, []);

  //アニメーション
  function startAnimation() {
    KUTE.fromTo(
      '#nftListRight',
      { opacity: 0 },
      { opacity: 1 },
      { duration: 100, easing: 'easingSinusoidalIn' },
    ).start();
  }

  //背景をタップ時
  const tapBack = () => {
    if (isFaceScreen) {
      if (isMobile) {
        //navigate('/');
        closeAnim();
      } else if (isElectron) {
        window.myapi.closeWindow();
      } else {
        navigate('/app');
      }
    } else {
      if (isMobile) {
        closeAnim();
      } else {
        setPageState('main');
      }
    }
  };

  function closeAnim() {
    let kute = KUTE.to(
      '#nftListRight',
      { top: '900px' },
      {
        duration: 300,
        easing: 'easingCubicOut',
        onComplete: () => {
          setPageState('main');
        },
      },
    );
    kute.start();
  }

  useEffect(() => {
    if (isMobile) {
      let kute = KUTE.to(
        '#nftListRight',
        { top: 'calc(env(safe-area-inset-top) + 0px)' },
        {
          duration: 300,
          easing: 'easingCubicOut',
          onComplete: () => {},
        },
      );
      kute.start();
    }
  }, []);

  //レンダービュー
  const renderScreen = () => {
    return (
      <>
        {/*ローディング*/}
        <Loading loadingState={metaLoadingState} />

        {/* NFTリストの表示　*/}
        {isFaceScreen == false && <div id="transparentBox" onClick={tapBack}></div>}

        <div id="nftListRight">
          {/* ヘッダータブエリア */}
          <div id="nftHeaderArea">
            <div id="nftCloseButton">
              <CloseSVG onClick={tapBack} />
            </div>
            <div id="nftHeader">
              <div
                id="nftBack"
                className={nftType == 'background' ? 'nftHeaderDiv selected' : 'nftHeaderDiv'}
                onClick={() => setNftType('background')}>
                <span style={nftType == 'background' ? { opacity: 1 } : { opacity: 0.5 }}>
                  <BackgroundSVG />
                </span>
                <div className="nftHeaderTitle">{t('nft.Background')}</div>
              </div>
              <div></div>
              <div
                id="nftBack"
                className={nftType == 'BGM' ? 'nftHeaderDiv selected' : 'nftHeaderDiv'}
                onClick={() => setNftType('BGM')}>
                <span style={nftType == 'BGM' ? { opacity: 1 } : { opacity: 0.5 }}>
                  <MusicSVG />
                </span>
                <div className="nftHeaderTitle">{t('nft.BGM')}</div>
              </div>
            </div>
          </div>

          <div id="nftListRightScroll" className="paddingWrap">
            <>
              {nftType == 'background' && <NFTBackground setNftType={setNftType} />}
              {nftType == 'BGM' && <NFTBGM setNftType={setNftType} />}
            </>
          </div>
        </div>
      </>
    );
  };

  return renderScreen();
}
